var exports = {
  "f": "assigneeContainer__krx3o6",
};

module.exports = exports;
